import '@/aiClientTools';
export { default } from '@erikdakoda/agent-ui/components/ForgeChatPage';

// Disable static generation for this page since it uses user context
export async function getServerSideProps() {
  return {
    props: {},
  };
}
